import { localeBonusesType } from '../en-US'

export const bonuses: localeBonusesType = {
  yourCashback: 'Su reembolso en efectivo',
  yourFirstDeposit: 'Su primer depósito',
  yourJackpot: 'Tu premio gordo',
  noBonuses: 'No tienes bonos',
  youGot: 'Tienes',
  bonusMin: 'Mín',
  bonusMax: 'Máx',
  bonus1div2: '1/2',
  bonusX2: 'X2',
  enterAmount: 'Introduce la cantidad',
  bonuses: 'Bonificaciones',
  moreAboutStock: 'Más sobre el stock',
  IncreasedByOwner: 'Aumentado por el propietario',
  DecreasedByOwner: 'Reducido por el propietario',
  ALL: 'Todos',
  Cashback: 'Devolución de efectivo',
  SportDiscount: 'Descuento deportivo',
  FirstDeposit: 'Primer depósito',
  DetractedFirstDepositBonusByWithdrawal: 'Bono de primer depósito detraído por retiro',
  IncreasedBySO: 'Aumentado por SO',
  TransferBonusesToBalance: 'Transferir bonificaciones al saldo',
  LuckySpin: 'Giro afortunado',
  balanceConvertedSuccess: 'Saldo agregado con éxito',
  exchange: 'Intercambio',
  bonusBalanceOnYourAccount: 'Su saldo actual de bonificación',
  exchangeRate: 'Tipo de cambio',
  balanceMustBeLess: 'El saldo debe ser inferior a',
  toCompleteExchange: 'para completar el intercambio',

  cashbackHistory: 'Historial de devolución de efectivo',
  from: 'De',
  to: 'Para',
  show: 'Mostrar',
  date: 'Fecha',
  filters: 'Filtros',
  type: 'Tipo',
  undefinedType: 'Tipo no definido',
  amount: 'Importe',
  cashbackNotify: 'Ha recibido un reembolso en efectivo por la cantidad de',
  thankYou: 'Gracias',
  firstDepositNotify: 'Ha recibido el primer depósito por la cantidad de',

  currentBonusBalance: 'Su saldo actual de bonificación',
  youWonJackpot: 'Has ganado el premio gordo!',
  pickUp: 'Recoger',
  takeYourPrize: 'Toma tu premio',
  yourBonus: 'Su bono',
  clickForPlayFreeSpins: '¡Haz clic para jugar giros gratis!',
  openGames: 'Abrir juegos',
  takeYourBonus: 'Toma tu bono',
  takeBonus: 'Bonos',
  wagerTextPromotion: (amount: number, currency: string) =>
    `Aprovecha tu bono para jugar y alcanzar el objetivo de ${amount} ${currency}`,
  giro: 'Giro',
  gratis: 'GRATIS',
  deposit: 'DEPÓSITO',
  collectWinnings: 'Cobrar ganancias',
  wonBonus: 'Bono ganado',
  activate: 'Activar',
  bonus: 'Bono',
  freeSpins: 'Giros gratis',
  status: 'Estado',
  expirationDate: 'Fecha de vencimiento',
  wager: 'Necesita recuperar',
  wagerComplete: 'Recuperado',
  conquest: 'CONQUISTA',
  AVAILABLE: 'Disponible',
  AVAILABLE_COMPLETED: 'Disponible',
  ACTIVE: 'Activo',
  EXPIRED: 'Caducado',
  COMPLETED: 'En apuesta',
  PAID: 'Pagado',
  WAIT: 'Esperar',
  freeSpinsGames: 'Abrir juegos',
  wagerCoef: 'Apuesta',
  rollOver: 'Roll-over',
  validityTerm: 'Término de validez',
  days: 'd',
  needToWinBack: 'Necesita recuperar',
  metaRollOver: 'VUELTA',
  target: 'Objetivo',
  targetAchieved: 'Objetivo alcanzado',
  balanceAchieved: 'Saldo alcanzado',
  bonusBackCardInfo:
    'Un Bono de Primer Depósito del 100% está disponible para todos los nuevos Jugadores de forma permanente. ' +
    'El bono de primer depósito se aplica solo al primer depósito del Jugador, es igual al 100% del monto ' +
    'del primer depósito. Dinero de bono – recompensas equivalentes a dinero real que el usuario recibe del casino ' +
    'de forma gratuita. Al solicitar un retiro de fondos, el bono no apostado en el primer ' +
    'depósito se cancela.',
  freeSpinBackCardInfo:
    'En nuestro casino, cada nuevo jugador puede obtener un cierto número de giros gratis al registrarse. ' +
    'Giro gratis es un giro en las tragamonedas cuando no se deduce dinero del saldo del jugador. ' +
    'Cuando te registras, ¡obtienes {freespinCount} GIROS GRATIS! El bono especificado se otorga solo una vez – ' +
    'directamente para el registro a nuevos jugadores que no tienen otras cuentas en el casino.',
  promotions: 'Promociones',
  active: 'Activo',
  available: 'Disponible',
  expired: 'Caducado',
  completed: 'Completado',
  awardsFestival: '¡Festival de Premios!',
  registerBonus: 'Registrar',
  moneySuccessfully: 'Dinero con éxito',
  successActivate: 'Activado con éxito',
  cancelBonus: 'Cancelar bono',
  spinsAreOver: 'Los giros han terminado',
  freeSpinsAreOver: 'Los giros gratis han terminado',
  freeSpinStart: '¡Atención! Los giros gratis solo se pueden usar en un juego: el que lances primero. ¿Continuar?',
  freeSpinStartHeader: 'Inicio de Giro Gratis',
  continue: 'Continuar',
  freeSpinEnd: 'Los giros gratis han terminado',
  changeActiveBonusText:
    'Cuando se activa un nuevo bono, el bono será suspendido. El bono suspendido puede ser activado de nuevo.',
  activatePromo:
    'Cuando se activa un nuevo bono, el bono actual será suspendido. Un bono suspendido puede ser activado de nuevo.',
  clear: 'Limpiar',
}
